
import {IHaveExecutionBounds, IHaveTags} from '../PA.Core/PA.Core.IF.Aspects'
import * as Rx from 'rxjs'
import {WB_CustomerRow, WB_FinishedProductRow, WB_ProductGroupRow, WB_TagRow} from "../PA.Core/PAdbSchemaRows";
import {IProgressProvider} from "../PA.Core/PA.Core.IF.Basic";
import {IHaveEvents} from "../PA.TPM.Core/PA.TPM.IF.Aspects";
import {EventBO} from "../PA.TPM.BusinessObjects/EventBO";
import {PlanBO} from "../PA.TPM.BusinessObjects/PlanBO";
import {HorizAlignment} from "../PA.UIM.Core/PA.UIM.Core.IF.Search";



//<editor-fold desc="Gantt Context for Plan/ Event">

export interface IEventCollectionContext {

  Register(anIHaveEvents: IHaveEvents): void;
  UnRegister(): void;
  readonly EventCollection: IHaveEvents

  readonly AllPlans: PlanBO[]
  readonly AllEvents: EventBO[]
  readonly IHaveEventsChanged: Rx.BehaviorSubject<IEventCollectionContext>;
  readonly LoadProgressProvider: IProgressProvider

  // Filter by Promoted Group...
  // Filter by Source Customer
  // Filter by Tag

  readonly SourceCustomers_All: WB_CustomerRow[]
  SourceCustomers_Selected: WB_CustomerRow[]

  readonly ProductGroups_All: WB_ProductGroupRow[]
  ProductGroups_Selected: WB_ProductGroupRow[]

  readonly Tags_All: WB_TagRow[]
  readonly Tags_Selected: WB_TagRow[]
  readonly Tags_IHaveTags: IHaveTags;

  readonly SelectionChanged: Rx.BehaviorSubject<IEventCollectionContext>;


  readonly FilteredEvents: EventBO[]
  FilteredEventsChanged: Rx.BehaviorSubject<IEventCollectionContext>;
}


export enum PlanMetricFieldType {
  number="number",
  string="string",
  boolean="boolean"
}
export interface IPlanMetric {
  id: string,
  name: string,
  type: string,
  editable: boolean,
  minValue?: any,
  maxValue?: any,
  copyPolicy?: boolean,
  formula: string,
  totalPolicy?: boolean,
  totalFormula?: string,
  aggregateTerms?: {[term_id:string]: (aRow:any) => number },
  format: { bShowThousandsSep?: boolean, iDecimalCount?: number, bShowSign?: boolean, bPercentage?: boolean, bShowCurrency?: boolean, sCurrencyField?: string, sDateFormat?: string },
  recordPropertyNames?: string[],
  renderOptions: {
    ui5?: {hAlign?: HorizAlignment, resourceId?: string}
  }
}

export interface IPlanMetricView {
  id: string,
  name: string,
  sort_order?:string,
  renderOptions:  {
    ui5?: {resourceId?: string}
  },
  PlanMetrics: IPlanMetric[],

}
export interface IMetricViewMetric {
  WB_MTRVIEW_ID:number,
  WB_MTRDFN_ID:number,
  METRIC_VIEW_ID: string,
  METRIC_VIEW_NAME: string,
  VIEWRENDEROPTIONS: string,
  VIWEORDER: string,
  METRIC_ID: string,
  METRIC_NAME: string,
  METRIC_DATATYPE: string,
  MINVALUE: string,
  MAXVALUE: string,
  EDITABLE_IND: string,
  COPYPOLICY: string,
  FORMULA: string,
  TOTALPOLICY: string,
  TOTAL_FORMULA: string,
  RECORD_PROPERTIES: string,
  TOTAL_AGGREGATION_TERMS: string,
  METRIC_FORMAT: string,
  METRICRENDEROPTIONS: string,
  METRICORDER: string
}
export interface metricProvider {
  id: string,
  name: string,
  type: number,
  editable: boolean,
  totalPolicy: boolean,
  formula: string,
  format: {bShowThousandsSep?: boolean, iDecimalCount?: number} , //"#0.00"
  recordPropertyNames?: string[],
  renderOptions:{
    ui5?: {hAlign?: HorizAlignment, resourceId?: string}
  }
}

export interface IPlanMetricViewProvider {
  getPlanMetricViews(arrPlanViewIds: string[]): Promise<IPlanMetricView[]>
  LoadPlanMetricViews(): Promise<IPlanMetricView[]>
}


//</editor-fold>

